// @mui
import { IconButton, MenuItem, MenuList, Popover, Stack } from '@mui/material';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import RenderViewButton from './RenderViewButton';
import { menuItemClasses } from '@mui/material/MenuItem';
import RenderEditButton from './RenderEditButton';
import RenderChangePasswordButton from './RenderChangePasswordButton';

// utils

// ----------------------------------------------------------------------

const RenderPopOverButton = ({ viewPermission, editPermission, delPermission, viewlink, editlink, onView, onEdit, onDel, editPWPermission, editPWlink, viewLabel = "View", editLabel = "Edit", viewIcon, viewDisabled = false, menuWidth = 140 }) => {
    const permissionArry = useSelector((state) => state.Login.permissionArry) || [];

    const viewAuthorize = permissionArry.includes(viewPermission)
    const editAuthorize = permissionArry.includes(editPermission)
    const editPWAuthorize = permissionArry.includes(editPWPermission)
    const delAuthorize = permissionArry.includes(delPermission)
    const [openPopover, setOpenPopover] = useState(null);
    const navigate = useNavigate()

    const handleOpenPopover = useCallback((event) => {
        setOpenPopover(event.currentTarget);
    }, []);

    const handleClosePopover = useCallback(() => {
        setOpenPopover(null);
    }, []);

    return (
        <>
            {
                (viewAuthorize || editAuthorize || delAuthorize) &&
                <>
                    <IconButton size="small" aria-label="Open row actions" aria-haspopup="menu" aria-expanded={Boolean(openPopover)} onClick={handleOpenPopover} sx={{ fontSize: 16, p: 0.5 }}>
                        <i className="ri-more-2-fill" />
                    </IconButton>
                    <Popover
                        open={!!openPopover}
                        anchorEl={openPopover}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuList
                            disablePadding
                            sx={{
                                p: 0.5,
                                gap: 0.5,
                                width: menuWidth,
                                display: 'flex',
                                flexDirection: 'column',
                                [`& .${menuItemClasses.root}`]: {
                                    px: 1,
                                    gap: 2,
                                    borderRadius: 0.75,
                                    [`&.${menuItemClasses.selected}`]: { bgcolor: 'action.selected' },
                                },
                            }}
                        >{
                                viewAuthorize && <MenuItem disabled={viewDisabled} sx={viewDisabled ? { '&.Mui-disabled': { opacity: 1, color: 'text.primary' } } : undefined} onClick={() => { handleClosePopover(); onView ? onView() : navigate(viewlink); }}>
                                    {viewIcon ? <i className={viewIcon} style={{ color: '#8291aa', fontSize: 16 }} /> : <RenderViewButton permission={viewPermission} />}{viewLabel}
                                </MenuItem>
                            }
                            {
                                editAuthorize && <MenuItem onClick={() => { handleClosePopover(); onEdit ? onEdit() : navigate(editlink); }}>
                                    {onEdit ? <i className="ri-pencil-line" style={{ color: '#8291aa', fontSize: 16 }} /> : <RenderEditButton permission={editPermission} />}{editLabel}
                                </MenuItem>
                            }
                            {
                                editPWAuthorize && <MenuItem onClick={(e) => navigate(editPWlink)}>
                                    <RenderChangePasswordButton permission={editPWPermission} />Password
                                </MenuItem>
                            }
                            {
                                delAuthorize && <MenuItem onClick={() => { handleClosePopover(); onDel(); }} sx={{ color: 'error.main' }}>
                                    <i className="ri-delete-bin-line" style={{ fontSize: 16, color: 'inherit' }} />Delete
                                </MenuItem>
                            }

                        </MenuList>
                    </Popover>
                </>

            }
        </>

    );
}
export default (RenderPopOverButton);
